import "./additional-details-section.css";

import { useContext, useMemo } from "react";

import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import { useSelectedAccessorials } from "~/features/quote/hooks/use-selected-accessorials.ts";

import { SelectedAccessorials } from "../../../shared/selected-accessorials.tsx";
import { CustomerReferencesSection } from "./customer-references-section.tsx";
import { EmergencyContactSection } from "./emergency-contact-section.tsx";
import { SpecialInstructionsSection } from "./special-instructions-section.tsx";

type AdditionalDetailsSectionProps = {
	hasFieldError?: (fieldName: string) => boolean;
	onClearFieldError?: (fieldName: string) => void;
};

export const AdditionalDetailsSection = ({
	hasFieldError,
	onClearFieldError,
}: AdditionalDetailsSectionProps = {}) => {
	const { quoteState } = useContext(QuoteDetailsContext);
	const hasHazmat = useMemo(
		() => quoteState.items.some((item) => item.isHazmat),
		[quoteState.items],
	);

	const allSelectedAccessorials = useSelectedAccessorials();

	return (
		<>
			<h2>Additional Details</h2>
			<div className={"additional-details-content"}>
				<CustomerReferencesSection />
				{hasHazmat ? (
					<EmergencyContactSection
						hasFieldError={hasFieldError}
						onClearFieldError={onClearFieldError}
					/>
				) : null}
				<div className={"additional-details-row"}>
					<SpecialInstructionsSection />
					<div className={"additional-details-value"}>
						<div className={"k-form-field"}>
							<div className={"k-label k-form-label"}>
								Selected Accessorials
							</div>
							<SelectedAccessorials accessorials={allSelectedAccessorials} />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
